import UnexpectedErrorPage from './UnexpectedErrorPage';

export default UnexpectedErrorPage;
